module.exports = __webpack_public_path__ + "static/img/pat.9627bc25.gif";